<template>
    <div class="ur-data-grid__noti-item" :class="notiClass">
        <ur-icon class="ur-data-grid__noti-icon--info" v-if="noti.type==='info'" >information</ur-icon>
        <ur-icon class="ur-data-grid__noti-icon--warn" v-if="noti.type==='warn'" >warning</ur-icon>
        <ur-icon class="ur-data-grid__noti-icon--err"  v-if="noti.type==='error'">error</ur-icon>
        <span class="ur-data-grid__noti-item__message">{{msg}}</span>
        <div class="ur-data-grid__noti-item__hourglass" v-if="noti.hour"/>
        <div class="ur-data-grid__noti-icon ur-data-grid__noti-icon--pin" v-if="noti.tmSuicide"
                @click="stopSuicide">
            <ur-icon>pin</ur-icon>
        </div>
        <div class="ur-data-grid__noti-icon ur-data-grid__noti-icon--close" v-else
                @click="suicideNow">
            <ur-icon>close</ur-icon>
        </div>
    </div>
</template>

<script>
export default {
    name : 'urDataGridNotiItem',
    inject : ['gridInfo'],
    props : {
        noti : null
    },
    computed : {
        msg() {return this.noti.msg || this.noti.text},
        notiClass() {
            var clazz = [];
            if(this.noti.type) {
                switch(this.noti.type.toLowerCase()) {
                case 'progress':
                case 'ing'    :
                case 'info'   :clazz.push('ur-data-grid__noti-item--info');break;
                case 'pass'   :
                case 'success':clazz.push('ur-data-grid__noti-item--pass');break;
                case 'warning':
                case 'warn'   :clazz.push('ur-data-grid__noti-item--warn');break;
                case 'fail'   :
                case 'error'  :
                case 'err'    :clazz.push('ur-data-grid__noti-item--err');break;
                default       :clazz.push('ur-data-grid__noti-item--log');break;}
            }
            if(this.noti.blur) {clazz.push('ur-data-grid__noti-item--blur')}
            return clazz;
        }
    },
    methods: {
        stopSuicide() {
            this.noti.blur = false;
            this.noti.hour = false;
            clearTimeout(this.noti.tmSuicide);
            this.noti.tmSuicide = null;
        },
        suicideNow() {
            this.noti.blur = true;
            // x. same as urCommonGridMixin.js
            this.noti.tmSuicide = setTimeout(() => {
                this.gridInfo.notis.find((v,i) => {
                    if(v !== this.noti) {return false;}
                    this.gridInfo.notis.splice(i,1);
                    return true;
                })
            },2000);
        }
    }
}

</script>
